import React, { useState, useEffect } from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import consolidatedStyle from './ConsolidatedOrdersPage.module.css'
import BackBar from '../../components/BackBar/BackBar';
import { Link } from 'react-router-dom';
import { FaMagnifyingGlass } from "react-icons/fa6";
import { DatePicker } from 'rsuite';

export default function ConsolidatedOrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSchool, setSelectedSchool] = useState('-Select-');
  const [schools, setSchools] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedFromYear, setSelectedFromYear] = useState("");
  const [selectedToYear, setSelectedToYear] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [applyFilters, setApplyFilters] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  useEffect(() => {
    fetchOrders();
    fetchSchools();
  }, []);


  useEffect(() => {
    let filtered = [...orders];

    // School filter
    if (selectedSchool !== "-Select-") {
      filtered = filtered.filter(order => order.school_id == selectedSchool);
    }

    // Date filter
    if (dateFrom && dateTo) {
      filtered = filtered.filter(order => {
        const orderDate = new Date(order.event_start_date.replace(' ', 'T')); // use your order date field
        return orderDate >= dateFrom && orderDate <= dateTo;
      });
    }

    // Search filter
    if (searchTerm !== "") {
      filtered = filtered.filter(order =>
        order.event_name?.toLowerCase().includes(searchTerm) ||
        order.school_name?.toLowerCase().includes(searchTerm)
      );
    }

    setFilteredOrders(filtered);

  }, [selectedSchool, dateFrom, dateTo, searchTerm, orders]);

  const getFilteredOrders = () => {
    return orders.filter(order => {

      const eventYear = new Date(order.event_end_date).getFullYear();

      return (
        (selectedSchool === "-Select-" || order.school_id == selectedSchool) &&
        (!selectedFromYear || eventYear >= selectedFromYear) &&
        (!selectedToYear || eventYear <= selectedToYear) &&
        (
          searchTerm === "" ||
          order.event_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          order.school_name?.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    });
  };

  const fetchSchools = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php?school_flag=ALL`
      );

      const data = await response.json();

      if (data.success) {
        setSchools(data.users);   // 👈 same as event page
      }

    } catch (error) {
      console.error('Error fetching schools:', error);
    }
  };

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_consolidated_orders.php`);
      const data = await response.json();
      if (data.status === 'success') {
        setOrders(data.orders || []);
        setFilteredOrders(data.orders || []);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleSchoolChange = (e) => {
    const schoolId = e.target.value;
    setSelectedSchool(schoolId);

    if (schoolId === "-Select-") {
      setFilteredOrders(orders);
    } else {
      const filtered = orders.filter(order =>
        order.school_id == schoolId
      );
      setFilteredOrders(filtered);
    }
  };

  const handleFromYearChange = (e) => {
    setSelectedFromYear(Number(e.target.value));
  };

  const handleToYearChange = (e) => {
    setSelectedToYear(Number(e.target.value));
  };

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/update_order_status.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: orderId,
          status: newStatus
        })
      });
      const data = await response.json();
      if (data.status === 'success') {
        // Refresh orders after status update
        fetchOrders();
      }
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };

  return (
    <>
      <AdminHeader />
      <div className={consolidatedStyle.consolidatedorderspage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={consolidatedStyle.consolidatedBody}>
                <div className={consolidatedStyle.consolidatedPartone}>
                  <div className="row align-items-end">
                    <div className="col-lg-7">
                      <div className="mb-3 row align-items-center">
                        <label className={`${consolidatedStyle.coplabels} col-sm-4 form-label pe-0 ${consolidatedStyle.maxWidth100}`}>School Name</label>
                        <div className="col-sm-8">
                          <select
                            className={`${consolidatedStyle.copformSelect} form-select`}
                            value={selectedSchool}
                            onChange={(e) => setSelectedSchool(e.target.value)}
                          >
                            <option value="-Select-">-Select-</option>

                            {schools.length > 0 ? (
                              schools.map((school, index) => (
                                <option key={index} value={school.school_id}>
                                  {school.school_name}
                                </option>
                              ))
                            ) : (
                              <option disabled>-No Data Available-</option>
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <label className={`${consolidatedStyle.coplabels} col-sm-4 form-label pe-0 ${consolidatedStyle.maxWidth100}`}>Date Range</label>

                        <div className="col-sm-4 pe-0">
                          <DatePicker
                            value={dateFrom}
                            onChange={(value) => {
                              if (value) {
                                const from = new Date(value);
                                from.setHours(0, 0, 0, 0);
                                setDateFrom(from);
                              } else {
                                setDateFrom(null);
                              }
                            }}
                            format="MM/dd/yyyy"
                            placeholder="From"
                            className={consolidatedStyle.copformControl}
                          />
                        </div>

                        <div className="col-sm-4">
                          <DatePicker
                            value={dateTo}
                            onChange={(value) => {
                              if (value) {
                                const to = new Date(value);
                                to.setHours(23, 59, 59, 999);
                                setDateTo(to);
                              } else {
                                setDateTo(null);
                              }
                            }}
                            format="MM/dd/yyyy"
                            placeholder="To"
                            className={consolidatedStyle.copformControl}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-lg-1"> </div>			 */}
                    <div className="col-lg-3">
                      <div className="row align-items-center">
                        <div className="col-sm-12">
                          <button
                            className={`${consolidatedStyle.consolidatedSearchbtn} mt-2 btn btn-primary d-flex justify-content-center align-items-center`}
                            onClick={() => {
                              // trigger useEffect to re-filter
                              setFilteredOrders([...orders]); // simple re-render
                            }}
                          >
                            <FaMagnifyingGlass className={`${consolidatedStyle.consolidatedSearchIcon} me-1`} /> Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={consolidatedStyle.consolidatedParttwo}>
                  <div className="table-responsive">
                    <table className={`${consolidatedStyle.cotable} table table-striped table-bordered`} style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th>Event Date</th>
                          <th>Close Date</th>
                          <th>School/Organization Name</th>
                          <th>Event Name</th>
                          <th>Coordinator Email</th>
                          <th>Tracking Status</th>
                          <th>Total Items</th>
                          <th>Total Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="8" className="text-center">Loading...</td>
                          </tr>
                        ) : filteredOrders.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center">No orders available</td>
                          </tr>
                        ) : (
                          (applyFilters ? getFilteredOrders() : orders).map((order) => (
                            <tr key={order.consolidated_id}>
                              <td className="text-center">{order.event_start_date}</td>
                              <td className="text-center">{order.event_end_date}</td>
                              <td className="text-center">
                                <Link to="">{order.school_name}</Link>
                              </td>
                              <td className="text-center">
                                <Link to="">{order.event_name}</Link>
                              </td>
                              <td className="text-center">
                                <Link to="">{order.coordinator_email}</Link>
                              </td>
                              <td className="p-0">
                                <select
                                  className={`${consolidatedStyle.coformSelect} form-select h-100`}
                                  value={order.status}
                                  onChange={(e) => handleStatusChange(order.order_id, e.target.value)}
                                >
                                  <option value="Open to Order">Open to Order</option>
                                  <option value="In Process">In Process</option>
                                  <option value="Missing Title">Missing Title</option>
                                  <option value="Filled">Filled</option>
                                  <option value="Shipped">Shipped</option>
                                </select>
                              </td>
                              <td className="text-center">{order.total_quantity}</td>
                              <td className="text-center">${order.total_amount}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}
